import { DetailedInsight } from '@api/api/insights';
import { RangeHorizon } from '@chart';

import { ChartBody } from './ChartBody';

interface PastEpisodesChartProps {
  assets?: {
    tag: string;
    snake: string;
    paneIndex: number;
  }[];
  episodes: DetailedInsight['episodes'];
  horizon: RangeHorizon;
}

export const PastEpisodesChart = ({
  assets,
  episodes,
  horizon,
}: PastEpisodesChartProps) => {
  if (!assets?.length) {
    return null;
  }

  return <ChartBody assets={assets} episodes={episodes} horizon={horizon} />;
};
